var _rect, _rect2, _rect3, _circle, _circle2, _rect4, _rect5, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoSearchResults = function SvgNoSearchResults(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 213,
    viewBox: "0 0 272 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0292969,
    y: 88,
    width: 91,
    height: 66,
    rx: 11,
    fill: "#F1F9FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 0.5,
    width: 55,
    height: 40,
    rx: 11,
    fill: "#F1F9FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 234.971,
    y: 121,
    width: 37,
    height: 27,
    rx: 9,
    fill: "#F1F9FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 55.6869,
    transform: "matrix(0.709622 -0.704583 0.709622 0.704583 130.527 88.4043)",
    stroke: "#90CAF9",
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 53.2682,
    transform: "matrix(0.709622 -0.704583 0.709622 0.704583 130.525 88.4043)",
    fill: "url(#paint0_linear_159_47735)",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.86449,
    height: 20.6598,
    transform: "matrix(0.709622 -0.704583 0.709622 0.704583 168.326 134.277)",
    fill: "#BBDEFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 17.7561,
    height: 61.1598,
    rx: 3.95983,
    transform: "matrix(0.709622 -0.704583 0.709622 0.704583 179.526 150.511)",
    fill: "#90CAF9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.026,
    cy: 207,
    rx: 87.5,
    ry: 6,
    fill: "url(#paint1_linear_159_47735)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_47735",
    x1: 88.6388,
    y1: 124.257,
    x2: 44.0742,
    y2: 8.54433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_47735",
    x1: 59.4425,
    y1: 209.4,
    x2: 224.289,
    y2: 205.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoSearchResults);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no-search-results.7fca4732d70bcca08e1839780ff529fe.svg";